import React from 'react';
import './aboutme.css'; // Import your CSS file
import profileImage from '../../img/about/about-0.jpg';
import { FaReact, FaShopify } from 'react-icons/fa'; // Import React icons // Import your profile image
import resumePDF from '../../img/Wazir_Mubashir_Resume.pdf'; // Import your resume PDF

const AboutMe = () => {
  return (
    <section id="about" className="about">
      <div className="container about-container" data-aos="fade-up">
        {/* Section Title */}
        <div className="section-title">
          <h2>About Me</h2>
          <p className="about-description">
            I am a dedicated front-end web developer with expertise in React.js and Shopify development. With 2 years of hands-on experience in the dynamic software industry, I specialize in crafting sophisticated, responsive, and intuitive web applications.I Successfully Deployed 100+ Projects In My Development Journey 
          </p>
        </div>

        {/* Profile Information */}
        <div className="row">
          <div className="col-lg-4">
            <img src={profileImage} alt="Profile" className="profile-img" />
          </div>

          {/* Details */}
          <div className="content-0">
          
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <h3 className="web-developer-title">React Js | Shopify Developer</h3>
                  <div className="row mb-4">
                    {/* Contact Information */}
                    <div className="col-lg-6">
                      <ul className="list-unstyled">
                        <li><strong>Phone:</strong> +923469657528</li>
                        <li><strong>Location:</strong> Islamabad, Pakistan</li>
                        <li><strong>Availability:</strong> Open for Freelance</li>
                      </ul>
                    </div>
                    
                    {/* Additional Information */}
                    <div className="col-lg-6">
                      <ul className="list-unstyled">
                        <li><strong>Education:</strong> B.Sc. Software Engineering</li>
                        <li><strong>Email:</strong> <a href="mailto:wazirmubashir2021@gmail.com" class="email-link">Wazirmubashir2021@gmail.com</a></li>
                        <li><strong>Professional Profile:</strong> .Liquid Programmer</li>
                      </ul>
                    </div>
                  </div>

                  {/* Specialties */}
                  <div className="row mb-4">
                    <div className="professional-heading">
                      <h4>Professional Attributes</h4>
                      <ul className="list-unstyled">
                        <li>Thrives in fast-paced environments</li>
                        <li>Strong problem-solving skills</li>
                        <li>Excellent team player</li>
                        <li>Adaptable and quick learner</li>
                        <li>Committed to delivering high-quality results</li>
                      </ul>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="buttons-container">
                        <a href={resumePDF} download className="primary-btn red-btn">Download Resume</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutMe;